import {Button, Dropdown} from 'platform/components';
import {Box} from 'platform/foundation';

import i18n from '@dms/i18n';

import {suffixTestId} from 'shared/web';

import {PredefinedNotesDropdownBody} from './PredefinedNotesDropdownBody';
import {PredefinedNotesProps} from './types/PredefinedNotesProps';

export function PredefinedNotes(props: PredefinedNotesProps) {
  return (
    <Box>
      <Dropdown
        isDisabled={props.isEditingDisabled}
        dropdownControl={
          <Button
            title={i18n.t('entity.vehicle.labels.templates')}
            variant={props.isLinkVariant ? 'link' : 'ghostLink'}
            leftIcon="content/add_circle"
            size="small"
            isDisabled={props.isEditingDisabled}
            data-testid={suffixTestId('templates', props)}
          />
        }
        data-testid={suffixTestId('predefinedNotes', props)}
      >
        <PredefinedNotesDropdownBody {...props} />
      </Dropdown>
    </Box>
  );
}
